export default __webpack_public_path__ + "static/media/medicine-3.4af5e908.png";